import { ComponentProps } from "react";
import { VariantProps, tv } from "tailwind-variants";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";

const styles = tv({
  slots: {
    base: "flex cursor-pointer flex-row items-center gap-20 border-b border-gray px-30 py-10",
    text: "max-w-[200px] truncate",
  },
  variants: {
    hoverColor: {
      red: { base: "hover:text-red" },
      default: { base: "hover:text-primary" },
    },
  },
  defaultVariants: {
    hoverColor: "default",
  },
});

export interface IDropdownItem extends ComponentProps<"li"> {
  leadingIcon?: IconProp;
  text: string;
  trailingIcon?: IconProp;
  onClick: () => void;
  hoverColor?: VariantProps<typeof styles>["hoverColor"];
  iconProps?: Omit<FontAwesomeIconProps, "icon">;
}

const DropdownItem = ({
  leadingIcon,
  text,
  trailingIcon,
  onClick,
  hoverColor,
  iconProps,
}: IDropdownItem) => {
  const { base, text: textStyles } = styles({ hoverColor });

  const renderIcon = (icon: IconProp) => (
    <FontAwesomeIcon icon={icon} fixedWidth {...iconProps} />
  );

  return (
    <li className={base()} data-testid={text} onClick={onClick}>
      {leadingIcon && renderIcon(leadingIcon)}
      <span className={textStyles()} title={text}>{text}</span>
      {trailingIcon && renderIcon(trailingIcon)}
    </li>
  );
};

export default DropdownItem;
